export const Routes = {
  API_HOSTNAME: process.env.REACT_APP_API_HOSTNAME,
  LEADFORMPUBLICURL: process.env.REACT_APP_LEADFORMPUBLICURL,

  LOGIN: "admin-login",
  GETDASHBOARDCOUNTER: "getdashboardcounter",
  USERLOGOUT: "logout",
  INSERTLEAD: "insertprimelead",
  GETPRIMENEWLEADLIST: "getallprimelead",
  UPDATEPRIMELEADSTATUS: "updateprimeleadstatus",
  GETPRIMELEADLIST: "getprimeleadbyid",
  GETPRIMELEADHISTORY: "getprimeleadhistory",
  GETPRIMELEADBYLID: "getprimeleadbylid",
  GETPRIMEALLOCATELISTBYID: "getprimeallocatelistbyid",
  LEADTRANSFERTO: "transferprimelead",
  INSERTFOLLOWUP: "insertfollowup",
  INSERTWELCOMEKITFOLLOWUP: "insertwelcomekitfollowup",
  INSERTMEMBERLEADREJECTREASON: "insertmemberleadrejectreason",
  INSERTLEADREJECTREASON: "insertleadrejectreason",
  UPDATELEADREJECTREASON: "updateleadrejectreason",
  DELETELEADREJECTREASON: "deleteleadrejectreason",
  GETPRIMELEADREJECTREASON: "getprimeleadrejectreason",
  UPDATEPRIMELEADMEMBERFORM: "updateprimelead",
  GETSTAFFBYPID: "getstaffbypid",
  INSERTSTAFF: "insertstaff",
  UPDATESTAFFDETAILS: "updatestaffdetails",
  UPDATESTAFFSTATUS: "updatestaffstatus",
  DELETESTAFF: "deletestaff",
  INSERTPRIMETRAININGWEBINAR: "insertprimetrainingwebinar",
  UPDATEPRIMETRAININGWEBINAR: "updateprimetrainingwebinar",
  DELETETRAININGWEBINAR: "deletetrainingwebinar",
  GETALLPRIMETRAININGWEBINAR: "getallprimetrainingwebinar",
  INSERTPRIMENOTIFICATION: "insertprimenotification",
  UPDATEPRIMENOTIFICATION: "updateprimenotification",
  DELETENOTIFICATION: "deletenotification",
  GETALLPRIMENOTIFICATION: "getallprimenotification",
  GETREADPRIMENOTIFICATIONDATA: "getreadprimenotificationdata",
  GETALLPRIMEPOLL: "getallprimepoll",
  DELETEPOLL: "deletepoll",
  GETPOLLPRIMERESULT: "getpollprimeresult",
  INSERTPRIMEPOLL: "insertprimepoll",
  UPDATEPRIMEPOLL: "updateprimepoll",
  GETNOTIFICATIONCHILDREN: "get-notification-children",
  GETPOLLCHILDREN: "get-poll-children",
  GETPOLLSELECT: "getprimepolloption",
  UPDATEPRIMEDESCRIPTIONSETTING: "setprimedescriptionsettings",
  GETCONTENTHISTORY: "getcontenthistory",
  GETALLUSER: "getuser",
  CHECKDUPLICATECONFIRMEDLEAD: "checkduplicateconfirmlead",
  INSERTPRIMEMEMBER: "insertprimemember",
  INSERTMEMBERSHIPFLOW: "insert-membership-flow",
  UPDATEMEMBERSHIPFLOW: "update-membership-flow",
  MEMBERSHIPFLOWIMAGEDELETE: "deletemembershipflowimage",
  GETPRIMEMEMBERSHIPFLOWLIST: "get-prime-membershipflow-list",
  INSERTPRIMEMAGAZINE: "insert-prime-magazine",
  GETPRIMEMAGAZINELIST: "getprimemagazinelist",
  MAGAZINEDELETE: "deletemagazine",
  UPDATEPRIMEMAGAZINE: "update-prime-magazine",
  CHECKMOBILEVALIDATION: "check-mobile-validation",
  UPDATEPRIMEMEMBER: "updateprimemember",
  GETALLPRIMEMEMBERLIST: "getallprimememberweb",
  GETPRIMEMEMBERBYID: "getprimememberbyid",
  UPDATEMEMBERSTATUS: "update-prime-member-status",
  INSERTMEMBERDEACTIVEREASON: "insertmemberdeactivereason",
  UPDATEMEMBERDEACTIVEREASON: "updatememberdeactivereason",
  DELETEMEMBERDEACTIVEREASON: "deletememberdeactivereason",
  GETPRIMEMEMBERDEACTIVEREASON: "getprimememberdeactivereason",
  UPDATESUGGESTIONANSWER: "updatesuggestionanswer",
  DELETESUGGESTIONATTACHMENT: "deletesuggestionattachment",
  GETPRIMESUGGESTIONLIST: "get-prime-suggestion-list",
  UPLOADSUGGESTIONCHUNK: "uploadsuggestionchunk",
  INSERTCANCELMEMBERSUBJECT: "insertcancelmembersubject",
  UPDATECANCELMEMBERSUBJECT: "updatecancelmembersubject",
  DELETECANCELMEMBERSUBJECT: "deletecancelmembersubject",
  GETCANCELMEMBERSUBJECT: "getcancelmembersubject",
  GETCANCELMEMBERREQUESTLIST: "getcancelmemberrequestList",
  APPROVECANCELMEMBERREQUEST: "approvecancelmemberrequest",
  INSERTLVBSESSIONPODCAST: "insertlvbsessionpodcast",
  UPDATELVBSESSIONPODCAST: "updatelvbsessionpodcast",
  GETALLLVBSESSIONPODCAST: "getlvbsessionpodcast",
  DELETELVBSESSIONPODCAST: "deletelvbsessionpodcast",
  INSERTPRIMEGREETING: "insert-prime-greeting",
  GETALLPRIMEGREETING: "getallprimegreeting",
  GREETINGDELETE: "deletegreeting",
  RESENDPRIMEGREETING: "resendprimegreeting",
  INSERTASKREJECTREASON: "insertaskrejectreason",
  UPDATEASKREJECTREASON: "updateaskrejectreason",
  DELETEASKREJECTREASON: "deleteaskrejectreason",
  GETPRIMEASKREJECTREASON: "getprimeaskrejectreason",
  GETPRIMEASKSLIST: "getprimeaskslist",
  ASKAPPROVEREJECT: "askapprovereject",
  GETPRIMECONFIRMMEMBERSLIST: "getallprimeconfirmmemberlead",
  UPDATEMEMBERWELCOMEKITSTATUS: "updatememberwelcomekitstatus",
  GETPRIMEMEMBERWELCOMEKITHISTORY: "getprimememberwelcomekithistory",
  GETNEWPRIMELEADDATAFOREXPORT: "get-new-prime-lead-for-export",
  GETPRIMEMEMBERWELCOMEKITDATAEXPORT: "get-prime-member-welcomekit-for-export",
  GETINVOICESETTING: "getinvoicesettings",
  UPDATEINVOICESETTING: "setinvoicesettings",
  UPDATESETTING: "setsettings",
  GETESETTING: "getsettings",
  GETPRIMEDASHBOARDCOUNTER: "getprimedashboardcounter",
  DOWNLOADMEMBERINVOCIE: "getmemberinvoice",
  GENERATEMEMBERINVOICE: "generate-member-invoice",
  INSERTCOUNTRY: "insert-country",
  INSERTSTATE: "insert-state",
  INSERTCITY: "insert-city",
  UPDATESTATE: "updatestate",
  UPDATECITY: "updatecity",
  INSERTCITYAMBASSODAR: "insertcityambassador",
  UPDATECITYAMBSSADORDEATILS: "updatecityambassodardeatils",
  UPDATESTATESTATUS: "update-statestatus",
  UPDATECITYSTATUS: "update-citystatus",
  GETACTIVEMEMBERBYCHPT: "getactivememberbychptweb",
  // GETCHAPTERBYCITY: "getchapterbycityid",
  GETCITYAMBASSADORBYID: "getcityambassadorbyid",

  EXPORTMEMBERALLSPECIFICDATA: "export-member-all-specific-data",
  GETFOLLOWUPLEADLIST: "getfollowuplead",
  GETALLCITY: "getallcityweb",
  GETALLSTATE: "getall-state",
  GETALLCOUNTRY: "getcountry",
  GETPRIMEMEMBERINVOICELIST: "get-prime-member-invoice-list",
  DOWNLOADINVOICEZIP: "download-invoice-list-zip",
  GETMEMBERCONNECTEDANDBLOCKLIST: "get-member-connected-and-block-list",
  UPDATECONNECTIONREQUESTMAILSTATUS: "updateconnectionrequestmailstatus",
  ORANGETICKAPPROVEREJECT: "orangetickapprovereject",
  GETAPPLICATIONROUTE: "getapplicationroute",
  ADDUPDATEAPPLICATIONROUTE: "addupdateapplicationroute",
  INSERTPROMOCODE: "insertpromocode",
  GETPROMOCODELIST: "getpromocodelist",
  UPDATEPROMOCODE: "updatepromocode",
  UPDATEPROMOCODESTATUS: "updatepromocodestatus",
  GETPROMOCODEWISEMEMBERLIST: "getpromocodewisememberlist",
  RESETPRIMEINVOICENUMBER: "resetprimeinvoicenumber",

  GETREFERRALWITHDRAWALREQUESTSTATUS: "getreferralwithdrawalrequeststatus",
  UPDATEREFERRALWITHDRAWALREQUESTSTATUS: "updatereferralwithdrawalrequeststatus",

  // Referral Report
  GETREFERRALMEMBERREPORT: "getreferralmemberreport",
  GETREFERRALMEMBERDETAIL: "getreferralmemberdetail",
  GETREFERRALMEMBERWALLETSETTING: "getreferralmemberwalletsetting",
  GETREFERRALWALLETSETTING: "getreferralwalletsetting",
  UPDATEREFERRALWALLETSETTING: "updatereferralwalletsetting",

  SEARCHMEMBERLIST: "searchmemberlist"
};
